import { BaseConnector } from './baseConnector';

class GlobalContentConnector extends BaseConnector {
  getLatestGlobalContentOfType(globalContentTypeId) {
    var url = `${this.baseApiUrl}/globalContent/${globalContentTypeId}/latest`;
    return this.authFetch(url);
  }

  createGlobalContent(globalContentTypeId, globalContent) {
    var url = `${this.baseApiUrl}/globalContent/${globalContentTypeId}`;
    return this.authPost(url, globalContent);
  }
}

export { GlobalContentConnector };
